import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Card, Container, Row } from 'react-bootstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ListSearchPopOver from '../../../shared/pop-over/list-search.pop-over';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLeftPanelSelector } from '../../../redux/saga/checkmateAuthorizationSelector';
import { getStoreSummaryRequest, selectedStoreRequest } from '../../../redux/actions/storeActions';
import { DASHBOARD_TEXT, STORE_TEXT } from '../../../constants/commonConstants';
import { orderDownloadDataSaga, orderDownloadLoadingSaga, orderDownloadSelectionSaga } from '../../../redux/saga/ordersPageSelectors';
import { delete_cookie, formatOrderData, formatPayoutByOrderData, formatPayoutData, generateDownload, getTargetDate, getCookie } from '../../../shared/utils/format.helpers';
import { CircularProgressLoader } from '../../../shared/components/Loaders';
import { clearDownloadTypeData } from '../../../redux/actions/ordersPageActions';
import { endDateRangeSaga, startDateRangeSaga } from '../../../redux/saga/dateRangeSelector';
import { payoutByOrderDownloadLoadingSaga, payoutByOrderDownloadRowsSaga, payoutByOrderDownloadSelectionSaga } from '../../../redux/saga/paymentsPageSelectors';
import mixpanel from 'mixpanel-browser';
import './Dashboard.scss';
import { initializaMerchantState } from '../../../redux/actions/amazonWebServicesAction';
import { initialRouteSaga, mixPanelDataSaga } from '../../../redux/saga/merchantServiceSelectors';
import { apiCallInProgressSaga, loginResponseSaga, refreshLogicSaga } from '../../../redux/saga/loginServiceSelector';
import { refreshTokenRequest, restoreUserSession } from '../../../redux/actions/loginServiceAction';
import AppMenu from '../../../shared/components/AppMenu';
import { CardContent, Dialog, DialogContent, DialogTitle, Divider, Typography } from '@mui/material';
import {
  MERCHANT_MISSING_BUTTON,
  MERCHANT_MISSING_DES,
  MERCHANT_MISSING_TITLE,
  SESSION_BUTTON,
  SESSION_BUTTON2,
  SESSION_DES,
  SESSION_TITLE,
  MERCHANT_NAME,
} from '../../../constants/merchantsConstants';
import { WarningOutlined } from '@mui/icons-material';
import { apiLoadingInProgressSaga } from '../../../redux/saga/accountServiceSelector';
import { useMerchant } from '../../../MerchantContext';
import { updateMixPanel } from '../../../redux/actions/merchantAction';
import { DOWNLOAD_REPORT, DOWNLOAD_REPORT_EVENT, DOWNLOAD_REPORT_FAILED, DOWNLOAD_REPORT_SUCCESS, N_A, ORDER_PAGE, PAYMENTS_PAGE, PAYOUTS_BY_ORDER_PAGE } from '../../../constants/mixPannelConstants';

const Dashboard = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [currentUser, setCurrentUser] = useState([]);
	const [openStoreList, setOpenStoreList] = useState(false);
	const [leftPanelOpen, setLeftPanelOpen] = useState(true);
	const toggleLeftPanel = useSelector(toggleLeftPanelSelector);
	const { merchantId, setMerchantId, merchantName } = useMerchant();
	const [storeId, setStoreId] = useState(null);
	const [storeName, setStoreName] = useState(MERCHANT_NAME);
	const [nameSelector, setNameSelector] = useState(DASHBOARD_TEXT);
	const [apiInProgress, setApiInProgress] = useState(false);
	const [currentSelection, setCurrentSelection] = useState('');
	const adminFlow = JSON.parse(sessionStorage.getItem('isAdmin'));
	let storeCallInProgress = false;
	const globalStartDate = useSelector(startDateRangeSaga) || sessionStorage.getItem('startDate');
	const globalEndDate = useSelector(endDateRangeSaga) || sessionStorage.getItem('endDate');
	const loadingInProgress = useSelector(apiCallInProgressSaga);
	const accountApILoading = useSelector(apiLoadingInProgressSaga);
	const paymentApILoading = useSelector(payoutByOrderDownloadLoadingSaga);
	const orderDownloadData = useSelector(orderDownloadDataSaga);
	const orderDownloadSelection = useSelector(orderDownloadSelectionSaga);
	const orderApiLoading = useSelector(orderDownloadLoadingSaga);
	const payoutByOrderDownload = useSelector(payoutByOrderDownloadRowsSaga);
	const payoutByOrderDownloadSelection = useSelector(payoutByOrderDownloadSelectionSaga);
	const initialRoute = useSelector(initialRouteSaga);
	const loginResponseData = useSelector(loginResponseSaga);
	const refreshLogic = useSelector(refreshLogicSaga);
	const mixPanelData = useSelector(mixPanelDataSaga);

	const [cookies, setCookie, removeCookie] = useCookies(['_tMerV', '_cMerV', '_rMerV']);

	const [openSessionPopOver, setOpenSessionPopOver] = useState(false);
	const [openMissingMerchant, setOpenMissingMerchant] = useState(false);
	window.sessionTimer;

	useEffect(() => {
		setLeftPanelOpen(toggleLeftPanel);
	}, [toggleLeftPanel]);

	useEffect(() => {
		setApiInProgress(loadingInProgress || accountApILoading || orderApiLoading);
	}, [loadingInProgress, accountApILoading]);

	const [sessionLogoutSeconds, setSessionLogoutSeconds] = useState(60);

	const sessionLogoutInterval = useRef(null);

	useEffect(() => {
		if (sessionLogoutSeconds === 0) {
		logoutHandle();
		}
	}, [sessionLogoutSeconds]);

	const startCounter = () =>
		(sessionLogoutInterval.current = setInterval(() => {
		setSessionLogoutSeconds((prevState) => prevState - 1);
		}, 1000));

	const stopCounter = () => {
		clearInterval(sessionLogoutInterval.current);
	};

	useEffect(()=>{
		if(mixPanelData){
			mixpanel.track(mixPanelData.type, mixPanelData.value);
		}
	},[mixPanelData]);

	useEffect(() => {
		if (loginResponseData && !loginResponseData?.msg) {
			let targetDate;
			let tMerObj;
			let cMerObj;
			let rMerObj;

			// console.log('LOGIC ', loginResponseData?.idToken, refreshLogic);
			if (loginResponseData?.idToken && !refreshLogic) {
				targetDate = getTargetDate(loginResponseData?.tokenTime);

				tMerObj = {
					idToken: loginResponseData.idToken,
					tokenTime: loginResponseData.tokenTime,
				};
				document.cookie = `_tMerV=${JSON.stringify(tMerObj)};expires=${targetDate};path=/;secure`;

				rMerObj = {
					refreshToken: loginResponseData.refreshToken,
				};
				document.cookie = `_rMerV=${JSON.stringify(rMerObj)};expires=${targetDate};path=/;secure`;

				cMerObj = {
					accessToken: loginResponseData.accessToken,
					expiresIn: loginResponseData.expiresIn,
					aggregator: loginResponseData.aggregator,
					merchantId: loginResponseData.merchantId,
					isAdmin: loginResponseData.isAdmin,
					userName: loginResponseData.userName,
					emailId: loginResponseData.emailId,
				};

				document.cookie = `_cMerV=${JSON.stringify(cMerObj)};expires=${targetDate};path=/;secure`;
				// console.log('WHOLE DATA LOGIN TIMER ', window.sessionTimer);
				if (!window.sessionTimer) {
				window.sessionTimer = setTimeout(() => {
					showSessionPopOver();
				}, (Number(loginResponseData.expiresIn) - 60) * 1000);
				// console.log('WHOLE DATA LOGIN ', loginResponseData, loginResponseData.expiresIn);
				}
			} else if (loginResponseData?.idToken && refreshLogic) {
				setApiInProgress(false);
				window.sessionTimer = undefined;
				targetDate = getTargetDate(loginResponseData?.tokenTime);
				// console.log('TOKEN TIME ', targetDate)
				tMerObj = {
					idToken: loginResponseData.idToken,
					tokenTime: loginResponseData.tokenTime,
				};
				document.cookie = `_tMerV=${JSON.stringify(tMerObj)};expires=${targetDate};path=/;secure`;

				rMerObj = {
					refreshToken: loginResponseData.refreshToken,
				};
				document.cookie = `_rMerV=${JSON.stringify(rMerObj)};expires=${targetDate};path=/;secure`;

				cMerObj = {
					accessToken: loginResponseData.accessToken,
					expiresIn: loginResponseData.expiresIn,
					aggregator: loginResponseData.aggregator,
					merchantId: loginResponseData.merchantId,
					isAdmin: loginResponseData.isAdmin,
					userName: loginResponseData.userName,
					emailId: loginResponseData.emailId,
				};

				document.cookie = `_cMerV=${JSON.stringify(cMerObj)};expires=${targetDate};path=/;secure`;
				// console.log('WHOLE DATA REFRESH 11 ',tMerObj, rMerObj, cMerObj)
				try {
					let currentTime = new Date().getTime();
					let tokenTime = new Date(cookies['_tMerV'].tokenTime).getTime();
					let tTime = cookies['_cMerV'].expiresIn * 1000 - (currentTime - tokenTime) - 60;
					if (tTime < 0) {
						tTime = 0;
					}
					if (!window.sessionTimer) {
						// console.log('TIME LEFT ', cookies['_cMerV'].expiresIn, currentTime - tokenTime, tTime);
						window.sessionTimer = setTimeout(() => {
						showSessionPopOver();
						}, tTime);
					}
				} catch (e) {
					// console.log('DASHBOARD ERR ', e);
					logoutHandle();
				}
			}
		}
		else if (loginResponseData && loginResponseData?.msg) {
			logoutHandle();
		}
	}, [loginResponseData]);

	useEffect(() => {
		if (getCookie('_cMerV') && getCookie('_tMerV') && getCookie('_rMerV') && loginResponseData === null) {
			if (JSON.parse(JSON.stringify(cookies['_tMerV']))?.idToken) {
				dispatch(restoreUserSession(cookies['_tMerV'], cookies['_cMerV'], cookies['_rMerV']));
			} else {
				logoutHandle();
				navigate('/');
			}
		} else {
			// console.log('DD1', getCookie('_cMerV') === null, getCookie('_tMerV') === null)
			if(!getCookie('_cMerV') || !getCookie('_tMerV') || !getCookie('_rMerV')){
				logoutHandle();
				navigate('/');
			}
		}
		if (storeCallInProgress === false) {
			storeCallInProgress = true;
		}
	}, []);

	useEffect(() => {
		if (merchantName) {
			setStoreName(merchantName);
		}
		if (merchantId && sessionStorage.getItem('isAdmin') === 'false') {
			dispatch(getStoreSummaryRequest(merchantId));
		}
	}, [dispatch, merchantId, merchantName]);

	useEffect(() => {
		let executionStart = new Date().getTime();
		if (orderDownloadData && orderDownloadData?.orders?.content && orderDownloadSelection && !orderDownloadData.msg) {
			setApiInProgress(true);
			if (orderDownloadSelection.length === 1) {
				if (window.location.pathname === '/dashboard/payments') {
				generateDownload(formatPayoutByOrderData(orderDownloadData), orderDownloadSelection, globalStartDate, globalEndDate, 'Payouts By Order');
				} else {
				generateDownload(formatOrderData(orderDownloadData), orderDownloadSelection, globalStartDate, globalEndDate, 'Order');
				}
				setTimeout(() => {
				setApiInProgress(false);
				}, 2000);
			} else if (orderDownloadSelection.length > 1) {
				doRecursiveDownloading(orderDownloadSelection, 0);
			} else {
				setApiInProgress(false);
				dispatch(clearDownloadTypeData([]));
			}
		} else {
			setApiInProgress(false);
			dispatch(clearDownloadTypeData([]));
		}
		let executionEnd = new Date().getTime();
		// console.log('EXECUTION TIME ',executionEnd, executionStart, currentSelection);
		if(orderDownloadData && orderDownloadSelection){
			if(executionEnd - executionStart > 0 && orderDownloadData?.orders?.content && orderDownloadData?.orders?.content.length > 0){
				dispatch(updateMixPanel({type: DOWNLOAD_REPORT, value: {
					buttonName: DOWNLOAD_REPORT_EVENT,
					outcome: DOWNLOAD_REPORT_SUCCESS,
					EventTime: new Date().toUTCString(),
					executionTime: executionEnd - executionStart,
					optionselected: orderDownloadSelection[0].label,
					daterangeselected: globalStartDate+'--'+globalEndDate,
					PageName: window.location.pathname === '/dashboard/payments' ? PAYOUTS_BY_ORDER_PAGE: ORDER_PAGE,
					timeSpent: N_A
				}, check: 'no'}));
			} else {
				dispatch(updateMixPanel({type: DOWNLOAD_REPORT, value: {
					buttonName: DOWNLOAD_REPORT_EVENT,
					outcome: DOWNLOAD_REPORT_FAILED,
					EventTime: new Date().toUTCString(),
					executionTime: executionEnd - executionStart,
					optionselected: orderDownloadSelection[0].label,
					daterangeselected: globalStartDate+'--'+globalEndDate,
					PageName: window.location.pathname === '/dashboard/payments' ? PAYOUTS_BY_ORDER_PAGE: ORDER_PAGE,
					timeSpent: N_A
				}, check: 'no'}));
			}
		}
		
	}, [orderDownloadData]);

	useEffect(() => {
		let executionStart = new Date().getTime();
		if (payoutByOrderDownload && payoutByOrderDownload?.merchantPayoutList?.content && payoutByOrderDownloadSelection && !payoutByOrderDownload.msg) {
			setApiInProgress(true);

		if (payoutByOrderDownloadSelection.length === 1) {
			generateDownload(formatPayoutData(payoutByOrderDownload), payoutByOrderDownloadSelection, globalStartDate, globalEndDate, 'Payments');
			setTimeout(() => {
			setApiInProgress(false);
			}, 2000);
		} else if (payoutByOrderDownloadSelection.length > 1) {
			doRecursiveDownloading(payoutByOrderDownloadSelection, 0);
		} else {
			setApiInProgress(false);
			dispatch(clearDownloadTypeData([]));
		}
		} else {
			setApiInProgress(false);
			dispatch(clearDownloadTypeData([]));
		}
		let executionEnd = new Date().getTime();
		// console.log('EXECUTION TIME ',executionEnd, executionStart);
		if(payoutByOrderDownload && payoutByOrderDownloadSelection){
			if(executionEnd - executionStart > 0 && payoutByOrderDownload?.merchantPayoutList?.content && payoutByOrderDownload?.merchantPayoutList?.content.length > 0){
				dispatch(updateMixPanel({type: DOWNLOAD_REPORT, value: {
					eventName: DOWNLOAD_REPORT_EVENT,
					outcome: DOWNLOAD_REPORT_SUCCESS,
					EventTime: new Date().toUTCString(),
					optionselected: payoutByOrderDownloadSelection[0].label,
					executionTime: executionEnd - executionStart,
					daterangeselected: globalStartDate+'--'+globalEndDate,
					PageName: PAYMENTS_PAGE,
					timeSpent: N_A
				}, check: 'no'}));
			} else {
				dispatch(updateMixPanel({type: DOWNLOAD_REPORT, value: {
					eventName: DOWNLOAD_REPORT_EVENT,
					outcome: DOWNLOAD_REPORT_FAILED,
					optionselected: payoutByOrderDownloadSelection[0].label,
					EventTime: new Date().toUTCString(),
					daterangeselected: globalStartDate+'--'+globalEndDate,
					executionTime: 0,
					PageName: PAYMENTS_PAGE,
					timeSpent: N_A
				}, check: 'no'}));
			}
		}
	}, [payoutByOrderDownload]);

	useEffect(() => {
		if (orderApiLoading) {
			setApiInProgress(true);
		}
	}, [orderApiLoading]);

	const showSessionPopOver = () => {
		setOpenSessionPopOver(true);
		setSessionLogoutSeconds(60);
		startCounter();
	};

	const logoutHandle = () => {
		stopCounter();
		window.sessionTimer = undefined;
		delete_cookie('_tMerV', '/', '');
		dispatch(initializaMerchantState({ type: 'RESET_STATE' }));
		sessionStorage.removeItem('userName');
		sessionStorage.removeItem('userEmail');
		sessionStorage.removeItem('endDate');
		sessionStorage.removeItem('startDate');
		sessionStorage.removeItem('selectedOption');
		sessionStorage.removeItem('isAdmin');
		sessionStorage.removeItem('merchantId');
		sessionStorage.removeItem('merchantName');
		delete_cookie('_cMerV', '/', '');
		delete_cookie('_rMerV', '/', '');
		navigate('/' + initialRoute);
	};

	const getToken = () => {
		setApiInProgress(true);
		dispatch(refreshTokenRequest(loginResponseData.userName, loginResponseData.emailId, loginResponseData.refreshToken));
	};

	const doRecursiveDownloading = (types, typeIndex) => {
		if (currentSelection === '/dashboard/payments') {
		generateDownload(formatPayoutData(orderDownloadData), [types[typeIndex]], globalStartDate, globalEndDate, 'Payouts By Order');
		} else if (currentSelection === '/dashboard/paymentByOrder') {
		generateDownload(formatPayoutByOrderData(payoutByOrderDownload), [types[typeIndex]], globalStartDate, globalEndDate, 'Payments');
		} else {
		generateDownload(formatOrderData(orderDownloadData), [types[typeIndex]], globalStartDate, globalEndDate, 'Order');
		}

		setTimeout(
		() => {
			if (types[typeIndex]) {
			doRecursiveDownloading(types, typeIndex);
			} else {
			setApiInProgress(false);
			dispatch(clearDownloadTypeData([]));
			}
		},
		2000,
		++typeIndex
		);
	};

	const handleClose = (e) => {
		// console.log('DDDD ', e, initialRoute);
		if (e === 'LOGOUT') {
			logoutHandle();
		} else {
			stopCounter();
			getToken();
			setOpenSessionPopOver(false);
		}
	};

	const onStoreListView = (value) => {
		setOpenStoreList(value);
		// console.log('DD ',value)
	};

	const onCloseHandler = () => {
		setOpenStoreList(false);
	};

	const storeSelectedHandler = (item) => {
		setStoreName(item.name.length > 25 ? item.name.substr(0, 25) + '\u2026' : item.name);
		setStoreId(item.sourceId.constructor === Array ? null : item.sourceId);
		dispatch(selectedStoreRequest(item.sourceId.constructor === Array ? [...item.sourceId] : [item.sourceId], item.storeUuid, item.sourceId));
		setNameSelector(item.sourceId.constructor === Array ? DASHBOARD_TEXT : STORE_TEXT);
		setOpenStoreList(false);
	};

	return (
		<div>
		<Container fluid className=' d-flex flex-column '>
			<Row>
			{leftPanelOpen ? (
				<div className='brand--col menu-section' style={{ width: '240px' }}>
				{adminFlow ? (
					''
				) : (
					<div className='brand--box'>
					<div className='brand--box1'>
						<h4 className='brand--box1--text'>
						{storeName ? `${storeName}` : ''} {storeId ? `(${storeId})` : ''}
						</h4>
						{openStoreList ? (
						<ExpandLessIcon className='brand--box1--expand' onClick={() => onStoreListView(false)} />
						) : (
						<ExpandMoreIcon className='brand--box1--expand' onClick={() => onStoreListView(true)} />
						)}
					</div>
					<h5 className='brand--box--type' data-testid='store-name-id'>
						{storeName === storeName ? DASHBOARD_TEXT : ''}
					</h5>
					</div>
				)}
				{adminFlow ? <br /> : null}
				<AppMenu logoutHandle={() => logoutHandle()} />
				</div>
			) : null}
			{leftPanelOpen ? (
				<div style={{ padding: '0', width: leftPanelOpen ? 'calc(100% - 240px)' : '' }}>
				<Outlet context={[currentUser]} />
				</div>
			) : (
				<div style={{ padding: '0', width: '100%' }}>
				<Outlet context={[currentUser]} />
				</div>
			)}
			</Row>
		</Container>

		<ListSearchPopOver open={openStoreList} onClose={onCloseHandler} storeSelected={storeSelectedHandler} />
		{apiInProgress === true ? (
			<div className='loader-style'>
				<CircularProgressLoader />
			</div>
		) : null}

		<Dialog
			className='dialog-session-cont'
			sx={{
			borderRadius: '20px',
			'& .MuiDialog-paper': {
				borderRadius: '16px',
				minWidth: '40vw',
				maxWidth: '50vw',
				maxHeight: '60vh',
			},
			margin: '0 auto',
			}}
			slotProps={{ dialog: { backgroundColor: 'red' } }}
			onClose={(event, reason) => {
			if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
				setOpenSessionPopOver(false);
			}
			}}
			open={openSessionPopOver}
		>
			<DialogTitle className='dialog-session-cont--title' data-testid='order-details-id'>
			{SESSION_TITLE}
			{/* <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /> */}
			</DialogTitle>
			<Divider />
			<DialogContent className='dialog-session-cont--panelcontent'>
			<Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
				<CardContent sx={{ textAlign: 'left', padding: '0px !important' }}>
				<Typography variant='h6' component='div' className='dialog-session-cont--des'>
					{SESSION_DES}
				</Typography>
				</CardContent>
			</Card>
			</DialogContent>
			<div className='dialog-session-cont--buttoncont'>
				<button className='dialog-session-cont--secondaryButton' onClick={() => handleClose('LOGOUT')}>
					{SESSION_BUTTON} {sessionLogoutSeconds}
				</button>
				<button className='dialog-session-cont--primaryButton' onClick={() => handleClose('UPDATE')}>
					{SESSION_BUTTON2}
				</button>
			</div>
		</Dialog>

		<Dialog
			className='dialog-missing-cont'
			sx={{
			borderRadius: '20px',
			'& .MuiDialog-paper': {
				borderRadius: '16px',
				minWidth: '40vw',
				maxWidth: '50vw',
				maxHeight: '60vh',
			},
			margin: '0 auto',
			}}
			slotProps={{ dialog: { backgroundColor: 'red' } }}
			onClose={(event, reason) => {
			if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
				setOpenMissingMerchant(false);
			}
			}}
			open={openMissingMerchant}
		>
			<DialogTitle className='dialog-missing-cont--title' data-testid='order-details-id'>
				<WarningOutlined className='blinking warning-icon' />
				{MERCHANT_MISSING_TITLE}
				{/* <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /> */}
			</DialogTitle>
			<Divider />
			<DialogContent className='dialog-missing-cont--panelcontent'>
				<Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
					<CardContent sx={{ textAlign: 'left', padding: '0px !important' }}>
					<Typography variant='h6' component='div' className='dialog-missing-cont--des'>
						{MERCHANT_MISSING_DES}
					</Typography>
					</CardContent>
				</Card>
			</DialogContent>
			<Divider />
			<div className='dialog-missing-cont--buttoncont'>
				<button className='dialog-missing-cont--secondaryButton' onClick={() => handleClose('LOGOUT')}>
					{MERCHANT_MISSING_BUTTON} {sessionLogoutSeconds}
				</button>
			</div>
		</Dialog>
		</div>
	);
};

export default Dashboard;
